import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Spin, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../../component/message/message'; // 提示信息弹窗
import trans from './translation';
const { Option } = Select;

const BatchUpdateAssignedAsModel = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [assignedList, setAssignedList] = useState([]);

    useEffect(() => {
        if (props.updateInfoModel?.cohortProgId) {
            academicSearch(props.updateInfoModel.cohortProgId)
        }
        form.setFieldsValue({});
    }, []);

    const academicSearch = (cohortProgId) => {
        Base.callBackApi("studentModuleAdmin/academicSearch", { cohortProgId: cohortProgId }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object.list ?? []
                setAssignedList(list)
                if (data.object.existMc === "Y" && list && list.length > 0) {
                    form.setFieldsValue({
                        academicSupervisorUserId: list[0].userId
                    });
                }
            } else {
                errFrameShow("error", data.msg);
            }
        });
    }

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const save = () => {
        form.submit()
    }

    const onCancel = (flag = false) => {
        props.onClose(flag);
    }
    const onSave = (values) => {
        messageShowHandler()
        values.studentModuleIdList = props.updateInfoModel.studentModuleIds
        Base.callBackApi("studentModuleAdmin/batchUpdateAs", values).then((data) => {
            if ("SUCCESS" === data.msg) {
                props.onClose(true);
            } else {
                errFrameShow("error", data.msg);
            }
        });
    }


    return (
        <Modal
            visible={true}//控制弹框是否显示
            title="Batch Update Assigned-AS"//标题
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            // width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '50%')}//弹框宽度
            width={'768px'}
            onCancel={() => onCancel(false)}//点击取消触发事件
            footer={[
                <Button key='save' className="sysBtn btnBlue" type="primary" onClick={save} icon={<CheckCircleOutlined />}>Update</Button>,
                <Button key='cancel' className="sysBtn" onClick={() => onCancel(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
            ]}
        >
            <Spin size="large" spinning={isLoad} tip={trans.dataBeSaving[Config.backLang]}>
                <Message ref={messageRef} />
                <Form form={form} onFinish={onSave}>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="">The selected student Assigned-AS will be update to below:</div>
                        </div>
                        <div className="sysInput ">
                            <Form.Item
                                name="academicSupervisorUserId"
                                rules={[
                                    { required: true, message: "Assigned-Academic-Supervisor is required." },
                                ]}
                            >
                                <Select className="sysSelect" placeholder="Assigned-Academic-Supervisor" >
                                    <Option value=''></Option>
                                    {assignedList.map((item) => <Option key={item.userId} value={item.userId}>{item.staffName}</Option>)}
                                </Select>
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Spin>
        </Modal>

    )

}

BatchUpdateAssignedAsModel.propTypes = {
    onClose: PropTypes.func.isRequired,
    updateInfoModel: PropTypes.object.isRequired
}

export default BatchUpdateAssignedAsModel;